import { SilometrixThresholdResponse } from './silometrix-threshold-list.types';
import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

export async function SilometrixThresholdListService() {
  const { response, data } = await BACKEND.get<SilometrixThresholdResponse>(ENDPOINT.METRICS_ALERTS_CONFIG);

  return {
    response,
    summary: data,
  };
}
